export default __webpack_public_path__ + "static/media/psLogo.e44179fd.svg";